import {
  EnvironmentProviders,
  InjectionToken,
  Injector,
  ProviderToken,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { isObservable } from 'rxjs';

import { isEffect } from './lib/is-effect';

const EFFECTS_PROVIDERS = new InjectionToken<ProviderToken<unknown>[]>('EFFECTS_PROVIDERS');

function initializeEffects(): void {
  const injector = inject(Injector);
  const providers = inject(EFFECTS_PROVIDERS);

  for (const provider of providers) {
    const currentProvider = injector.get(provider);

    for (const effectFactory of Object.values(currentProvider)) {
      if (isEffect(effectFactory)) {
        const factory = effectFactory();

        if (isObservable(factory)) {
          factory.subscribe();
        }
      }
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function provideEffects(providers: any[]): EnvironmentProviders {
  return makeEnvironmentProviders([
    ...providers,
    {
      provide: EFFECTS_PROVIDERS,
      useValue: providers,
    },
    provideAppInitializer(initializeEffects),
  ]);
}

export { isEffect } from './lib/is-effect';
export { createEffect } from './lib/create-effect';
